<template>
    <v-card-text>
        <v-row v-if="loading">
            <v-col cols="12" md="7">
                <v-skeleton-loader type="table-row@3"></v-skeleton-loader>
            </v-col>
        </v-row>
        <div v-if="!loading" style="overflow: auto; border-left: thin solid rgba(255, 255, 255, 0.18) !important;">
            <v-data-table
                :headers="headers"
                :items="items"
                hide-default-footer
                disable-pagination
                class="table__lined">
                <template v-slot:body="{ items }">
                    <tbody>
                    <tr v-for="item in items" :key="item.providerId">
                        <td>{{ item.providerName }}</td>
                        <td>{{ item.sourceName }}</td>
                        <td>{{ item.leadsCount }}</td>
                        <td>
                            {{ item.contractsCount }}
                            (<span v-html="$helper.report.getPercentageHtml(item.contractsCount, item.leadsCount)"></span>)
                        </td>
                        <td>{{ $helper.format.currency(item.costTotal) }}</td>
                        <td>{{ $helper.format.currency(item.revenueTotal) }}</td>
                        <td>
                            <span :class="getRoiColor(item.roiPercent)">
                                {{ Math.round(item.roiPercent) }}%
                            </span>
                        </td>
                    </tr>
                    </tbody>
                </template>
            </v-data-table>
        </div>
    </v-card-text>
</template>

<script>
import ReportService from "@/_services/ReportService";
import {reportHelper} from "@/_helpers/report/reportHelper";

export default {
    name: 'ReportRoi',
    props: {
        filter: Object,
    },
    data: function () {
        return {
            loading: false,
            items: [],
            headers: [
                {text: 'Контрагент', value: 'providerName'},
                {text: 'Источник', value: 'sourceName'},
                {text: 'Лидов', value: 'leadsCount'},
                {text: 'Договоров', value: 'contractsCount'},
                {text: 'Затраты', value: 'costTotal'},
                {text: 'Выручка', value: 'revenueTotal'},
                {text: 'ROI', value: 'roiPercent'},
            ]
        }
    },
    methods: {
        fetch() {
            this.loading = true;
            ReportService.getSourceRoiReport(this.filter).then(report => {
                this.items = report.items;
                this.loading = false;
            });
        },
        getRoiColor(roiPercent) {
            return reportHelper.getStatColor(roiPercent, {
                colors: {
                    red: [-999999, -0.01],
                    yellow: [0, 49.99],
                    green: [50, 999999]
                }
            });
        }
    },
    created() {
        this.fetch();
    }
};
</script>
